/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols
export enum GoalType {
  Core = 'Core',
  Local = 'Local',
}
